import { SupportingFilesType } from '../../helpers/types';
import axios from '../../helpers/axios-setup';

export const getSupportingFileInfo = (type: SupportingFilesType) => axios.get(`/supporting-documents/${type}`);
